import React from 'react'
import ContentLoader from 'react-content-loader'

const TableSkeleton = ({
    speed = 2, width = "100%", height = 400, viewBox = "0 0 100% 400",
    backgroundColor = "#f3f3f3", foregroundColor = "#e1e1e1",noOfRows=8,
    rowWidth="100%",rowHeight="28",xValue="0",yValue="10"
}) => {
    return (
        <ContentLoader
            speed={speed}
            width={width}
            height={height}
            viewBox={viewBox}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
        >
            {
                new Array(noOfRows).fill("skell").map((el,i)=>{
                    return(
                        <rect x={xValue} y={Number(yValue) + i * (Number(rowHeight) + 10)} rx="0" ry="0" width={rowWidth} height={rowHeight} />
                    )
                })
            }
           

        </ContentLoader>
    )
}

export default TableSkeleton